import { type Space, bytesToNDigits } from '@mail/cross-sizes-utils';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MOBILE_OR_TABLET_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

/** https://jira.vk.team/browse/CLOUDWEB-19300 Модалка для оверквотеров при переносе в корзину */

type DiscountOnRemoveVariant = 'a' | 'b' | 'c' | 'd';

interface DiscountOnRemoveType {
    enabled: boolean;
    tariff: string;
    isRegular: boolean;
    isTrial: boolean;
    isDiscount: boolean;
    tariffQuota: Space;
    tariffDiscountValue: number;
}

const discountOnRemoveAB: DiscountOnRemoveVariant =
    !IS_MOBILE_OR_TABLET_BROWSER && !IS_WEBVIEW && !IS_BIZ_USER && getFeature('discount-on-remove-ab');

interface TariffInfo {
    quota: number;
    discountValue: number;
    regular: string;
    discount: string;
    trial: string;
}

const discountOnRemoveTariffInfo: TariffInfo = getFeature('discount-on-remove-tariff');

// Конфигурируем квоту и скидку явно, чтобы грузить ручку биллинга только при покупке, во избежание инцидента;
const tariffQuota = discountOnRemoveTariffInfo?.quota || 256;
const discountValue = discountOnRemoveTariffInfo?.discountValue || 50;
const regularTariffId: string = discountOnRemoveTariffInfo.regular || 'W256G1m_single_quota_2022_cloud';
const discountTariffId: string = discountOnRemoveTariffInfo.discount || 'W256GB_1y_public_clamps';
const trialTariffId: string = discountOnRemoveTariffInfo.trial || 'W256GB_1m_public_clamps_force_trial';

const tariffsByVariant = {
    b: regularTariffId,
    c: discountTariffId,
    d: trialTariffId,
} as const;

export const discountOnRemove: DiscountOnRemoveType = {
    tariffQuota: bytesToNDigits(tariffQuota * 1024 * 1024 * 1024, 3),
    tariffDiscountValue: discountValue,
    tariff: tariffsByVariant[discountOnRemoveAB],
    enabled: !!discountOnRemoveAB && discountOnRemoveAB !== 'a',
    isRegular: discountOnRemoveAB === 'b',
    isDiscount: discountOnRemoveAB === 'c',
    isTrial: discountOnRemoveAB === 'd',
};

/** https://confluence.vk.team/pages/viewpage.action?pageId=1178954077  */
registerExperiment('dscntrmv', discountOnRemoveAB, [
    AnalyticEventNames.DISCOUNT_ON_REMOVE_MODAL_SHOW,
    AnalyticEventNames.DISCOUNT_ON_REMOVE_MODAL_CLICK,
    AnalyticEventNames.DISCOUNT_ON_REMOVE_MODAL_CLOSE,
    AnalyticEventNames.DISCOUNT_ON_REMOVE_MODAL_CANCEL,
    AnalyticEventNames.FAST_CHECKOUT_SHOWN,
]);
